import { axios } from "@Root/API";

export const getStudiesStudyProgrammePostgradOptions = () => {
  return axios.get("get-data-for-post-grad");
};
